import { type ReactNode } from 'react'
import { Navigation } from './Navigation'

interface LayoutProps {
  children: ReactNode
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-primary-deep">
      {/* Background gradient effect */}
      <div className="fixed inset-0 bg-gradient-depth pointer-events-none" />
      <div className="fixed inset-0 bg-glow-radial pointer-events-none opacity-50" />

      {/* Navigation */}
      <Navigation />

      {/* Main content */}
      <main className="relative pt-20 pb-12 min-h-screen">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {children}
        </div>
      </main>
    </div>
  )
}
